/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from "prop-types";
import { VideoCard } from "@gonoodle/gn-universe-ui";
import { ImageSourcesType } from "@gonoodle/gn-universe-ui/types";

import {
  ROUTE_PREFIX,
  SPONSORED_PARTNER_TYPES,
  IMPRESSION_TYPES,
} from "../constants";
import { WithContentLink } from "../containers";
import { useImpression } from "../utils/hooks";

const VideoCardWithLink = WithContentLink(VideoCard);

export default function VideoTile({
  id,
  slug,
  duration,
  sponsor,
  subtitle,
  title,
  description,
  images,
  onPress,
  linkParams,
  impressionsProps,
}) {
  const inViewRef = useImpression({
    properties: {
      ...impressionsProps,
      impressionType: IMPRESSION_TYPES.VIDEO_TILE,
      videoVersionId: id,
    },
    enabled: !!impressionsProps,
  });

  return (
    <VideoCardWithLink
      ref={inViewRef}
      duration={duration}
      sponsorExpDate={sponsor && sponsor.expiration}
      subtitle={subtitle}
      title={title}
      description={description}
      id={id}
      slug={slug}
      images={images}
      contentLinkAsBase={`/${ROUTE_PREFIX.VIDEOS}`}
      contentLinkHrefBase={`/${ROUTE_PREFIX.VIDEOS}/[...identity]`}
      linkParams={{ ...linkParams }}
      handleClick={() => {
        onPress();
      }}
    />
  );
}

VideoTile.propTypes = {
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  duration: PropTypes.number.isRequired,
  sponsor: PropTypes.shape({
    expiration: PropTypes.string,
    type: PropTypes.oneOf([
      SPONSORED_PARTNER_TYPES.LONG_TERM_SPONSOR,
      SPONSORED_PARTNER_TYPES.PROMOTIONAL_ACTIVITY,
      "channel",
    ]).isRequired,
  }),
  subtitle: PropTypes.string,
  images: PropTypes.shape({ tile: ImageSourcesType }).isRequired,
  impressionsProps: PropTypes.shape({}),
  linkParams: PropTypes.shape({}),
  onPress: PropTypes.func,
};

VideoTile.defaultProps = {
  subtitle: undefined,
  sponsor: undefined,
  impressionsProps: undefined,
  linkParams: undefined,
  onPress: () => {},
};
